<template>
  <svg role="img" xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none" aria-label="Facebook's logo">
    <circle cx="18.5" cy="18.5" r="18" transform="rotate(-180 18.5 18.5)" stroke="#3E5974" />
    <path
      d="M21.8223 19.7182L22.264 16.9144H19.5432V15.0919C19.5432 14.3252 19.923 13.576 21.1377 13.576H22.3921V11.1884C21.6616 11.072 20.9234 11.009 20.1836 11C17.9443 11 16.4823 12.345 16.4823 14.7764V16.9144H14V19.7182H16.4823V26.5H19.5432V19.7182H21.8223Z"
      fill="currentColor"
    />
  </svg>
</template>
